import { columnsOrder, secondHeadings, topHeading } from './constants';
import EnvironmentGuard from '../../../../components/EnvironmentGuard';
import PackagedAppsByDeviceIdTable from './PackagedAppsByDeviceIdTable';
import useFetchPackagedAppsByDeviceId from '../../../../queries/useFetchPackagedAppsByDeviceId';
import { useParams } from 'react-router-dom';

const PackagedApps = () => {
  const { deviceId } = useParams();

  const {
    isLoading,
    data: results,
    lastElementRef,
    isFetching,
    totalCount,
    query,
  } = useFetchPackagedAppsByDeviceId({deviceId});

  return (
    <EnvironmentGuard>
      <PackagedAppsByDeviceIdTable
        isLoading={isLoading}
        results={results}
        lastElementRef={lastElementRef}
        isFetching={isFetching}
        topHeading={topHeading}
        secondHeadings={secondHeadings}
        columnsOrder={columnsOrder}
        totalCount={totalCount}
        query={query}
      />
    </EnvironmentGuard>
  );
};

export default PackagedApps;
